// @ts-check

/** @file Re-exports the shared HTML renderer. */

export {default} from "./render-html/index"
